import { ArrowLeft, ArrowRight, ZoomIn, ZoomOut } from '@mui/icons-material';
import { Box, Button, IconButton } from '@mui/material';
import * as React from 'react';
import { pdfjs, Document, Page } from "react-pdf";
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

type ScaleMode = 'width' | 'height' | 'custom';

export interface IPdfViewerProps {
    fileDownloadUri: string;
    currentWidth?: number;

}

export default function PdfViewer(props: IPdfViewerProps) {
    const { fileDownloadUri } = props;
    const containerRef = React.useRef<HTMLDivElement>(null);
    const [zoomLevel, setZoomLevel] = React.useState(1);
    const [scaleMode, setScaleMode] = React.useState<ScaleMode>('custom');
    const [pageSize, setPageSize] = React.useState({ width: 0, height: 0 });

    function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
        setPageNumber(1);
        setNumPages(numPages);
    }

    const zoomIn = () => {
        setScaleMode('custom');
        setZoomLevel(prev => Math.min(prev + 0.2, 3));
    };

    const zoomOut = () => {
        setScaleMode('custom');
        setZoomLevel(prev => Math.max(prev - 0.2, 0.1));
    };

    const resetZoom = () => {
        setScaleMode('custom');
        setZoomLevel(1);
    };
    const [numPages, setNumPages] = React.useState<number>();
    const [pageNumber, setPageNumber] = React.useState<number>(1);

    function nextPage() {
        setPageNumber((v) => ++v);
    }
    function prevPage() {
        setPageNumber((v) => --v);
    }
    // const fitToWidth = () => {
    //     if (containerRef.current && pageSize.width) {
    //         const containerWidth = containerRef.current.clientWidth - 40; // padding
    //         setZoomLevel(containerWidth / pageSize.width);
    //         setScaleMode('width');
    //     }
    // };

    // const fitToHeight = () => {
    //     if (containerRef.current && pageSize.height) {
    //         const containerHeight = containerRef.current.clientHeight - 80; // controls + padding
    //         setZoomLevel(containerHeight / pageSize.height);
    //         setScaleMode('height');
    //     }
    // };

    // 
    return (
        <div ref={containerRef} style={{
            height: "calc(100vh - 240px)", overflow: 'auto', width: props.currentWidth ?? '100%'

        }}>
            <Box display='flex' >
                <IconButton onClick={zoomOut}><ZoomOut /></IconButton>
                <Button variant='outlined' onClick={resetZoom}>{Math.round(zoomLevel * 100)}%</Button>
                <IconButton onClick={zoomIn}><ZoomIn /></IconButton>
                <Box >
                    <IconButton onClick={prevPage} disabled={pageNumber <= 1}>
                        <ArrowLeft />
                    </IconButton>
                    {pageNumber} z {numPages}
                    <IconButton onClick={nextPage} disabled={pageNumber >= (numPages ?? -1)}>
                        <ArrowRight />
                    </IconButton>
                </Box>
            </Box>
            <Document
                renderMode='canvas'
                file={fileDownloadUri}
                onLoadSuccess={onDocumentLoadSuccess}
            >
                <Page
                    scale={zoomLevel}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                    pageNumber={pageNumber}
                    onLoadSuccess={({ width, height }) => setPageSize({ width, height })}
                />
            </Document>
        </div>
    );
}